export const sendMessageToWhatsApp = () => {
  const phoneNumber = '+525555051060'; // Replace this with the recipient's phone number
  const message = 'Me gustaria conocer mas de Jahn Institute!'; // Replace this with your message
  
  const formattedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${phoneNumber}?text=${formattedMessage}`;

  window.open(url, '_blank');
};
